import { LinescoreEffects } from "./linescore.effect";
import { ExportEffects } from './export.effects';
import { ReportCacheEffects } from './cache.effects';
import { AuthEffects } from "./auth.effects";

export const reportsEffects: Array<any> = [
    LinescoreEffects,
    ExportEffects,
    ReportCacheEffects,
    AuthEffects
];
